export enum PageFieldsCodes {
  ID_REPORT = 'idReport',
}
